import { Avatar } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  avatar: {
    fontSize: '32px',
    background: '#1C2541',
    color: '#F5F5F5',
    width: '72px',
    height: '72px',
    marginRight: '10px',
  },
  avatarSmall: {
    fontSize: '12px',
    height: '24px',
    width: '24px',
  },
  avatarMedium: {
    fontSize: '14px',
    height: '36px',
    width: '36px',
  },
}));

type Props = {
  avatarUrl?: string | null;
  firstName: string;
  size?: 'sm' | 'md' | 'lg';
};

const UserAvatar = ({ avatarUrl, firstName, size = 'lg' }: Props) => {
  const classes = useStyles();

  return (
    <>
      {avatarUrl ? (
        <Avatar
          className={clsx(classes.avatar, {
            [classes.avatarSmall]: size === 'sm',
            [classes.avatarMedium]: size === 'md',
          })}
          src={avatarUrl}
        />
      ) : (
        <Avatar
          className={clsx(classes.avatar, {
            [classes.avatarSmall]: size === 'sm',
            [classes.avatarMedium]: size === 'md',
          })}
        >
          {firstName.charAt(0)}
        </Avatar>
      )}
    </>
  );
};

export default UserAvatar;
